import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import { MenuItemInput } from '../../shared/form/FormInput';
import { AppLogo, ProfileAvatar, RenderHeaderAppLogo, RenderHeaderText } from '../../shared/components/ConditonalComponent';
import { logout } from '../../shared/settings/auth';
import { actions } from '../../redux/actions';

// style imports
import './Header.scss';

const menuItem = {
    icon: <ProfileAvatar />,
    items: [
        {
            id: 5,
            label: 'Logout',
            type: 'menu'
        },
        {
            id:6,
            label: 'Terms and conditions',
            type: 'terms'
        }
    ]
};

const Header = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    // const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);
    const loggedInUserData = useSelector((state) => state.user );
    const screenName = useSelector(state => state.constant.screenName);

    return (
        <header className="d-flex border-bottom header-box align-items-center">
            

            {
                props.public ? 
                <AppLogo publicHeader={true} /> : 
                <div className='d-flex align-items-center gap-3 w-100'>
                    <button className="d-lg-none border-0 bg-transparent d-flex align-items-center justify-content-center" style={{ color: 'red', padding: 0 }} onClick={() => dispatch(actions.setSideBar(true))}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                    </button>
                    <div className='welcome-section'>
                        <h1>{screenName}</h1>
                        <div className='welcome-label'>Welcome back, {loggedInUserData.first_name} {loggedInUserData.last_name}</div>
                    </div>
                    <button className="ms-auto border-0 bg-transparent d-flex align-items-center justify-content-center" style={{ color: 'red', padding: 0 }} onClick={() => logout(history)} title="Logout">
                        <LogoutIcon style={{ fontSize: 28 }} />
                    </button>
                </div>
            }
            
            {/* <div className='w-100 d-flex position-relative'>

                <RenderHeaderText />

                <RenderHeaderAppLogo isSidebarOpen={isSidebarOpen} />
                
                <div className='d-flex align-items-center justify-content-end header-content-box'>
                    {
                        (loggedInUserData?.id && !props.location.pathname.includes("public")) && 
                        <div className='d-flex gap-2 gap-lg-3 justify-content-end px-3'>
                            <Link className="d-flex align-items-center">
                                <img style={{ width: '1.5rem' }} src={`${process.env.PUBLIC_URL}/static/images/question.png`} alt={"question"} />
                            </Link>
                            <MenuItemInput icon={menuItem.icon} items={menuItem.items} data={{}} onClick={(id) => {
                                switch (id) {
                                    case id:
                                        logout(props.history)
                                        break;

                                    default:
                                        break;
                                }
                            }} />
                        </div>
                    }
                </div>
            </div> */}
            
        </header>
    )
}

export default Header;
